<template>
  <div>
    <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
              <h3>Nuova persona</h3>
          </section>
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
              <div class="form-group row">
                  <label for="person_id" class="">{{__('forms.Project.person')}}</label>
                    <multiselect required="true" v-model="selectedPerson" :options="people" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group row">
                  <label for="role_id" class="">{{__('forms.Project.role')}}</label>
                     <multiselect required="true" v-model="selectedRole" :options="roles" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group row">
                  <label for="responsible_person_id" class="">{{__('forms.Project.responsible_person')}}</label>
                      <multiselect required="true" v-model="selectedResponsiblePerson" :options="responsibles" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group row">
                  <label for="started_at" class="">{{__('forms.PeopleRoles.startDate')}}</label>
                    <input class="form-control" type="date" name="project_role[started_at]" v-model="started_at" required>
              </div>
                <div class="form-group row">
                  <label for="ended_at" class="">{{__('forms.PeopleRoles.endDate')}}</label>
                    <input class="form-control" type="date" name="project_role[ended_at]" v-model="ended_at">
              </div>
                <input type="hidden" name="_token" :value="csrf">
                <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                <input type="hidden" name="project_role[person_id]" :value="this.selectedPerson.id">
                <input type="hidden" name="project_role[role_for_project_id]" :value="this.selectedRole.id">
                <input type="hidden" name="project_role[responsible_person_id]" :value="this.selectedResponsiblePerson.id">
              <div class="form-buttons clear">
                  <button type="submit" class="btn btn--green">{{ __('misc.update') }} </button>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>

  export default {
    // <multiselect v-model="value" :options="options"></multiselect>
    // OR register locally
    //components: { Multiselect },
    data () {
      return {
        value: null,
        editing: false,
        active: false,
        action: "",
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectedPerson: {},
        selectedRole: {},
        selectedResponsiblePerson: {},
          started_at: null,
          ended_at: null,

      }
    },
    methods: {
      toggle(action, item_id, editing, attributes) {
        console.log(attributes.roles);
        this.active = true;
        this.action = action;
        this.editing = editing;
        let url = attributes.url;
        if (url!==undefined) {
          if (url.indexOf("[id]")>0) {
            url = url.replace("[id]", item_id);
          }
          axios.get(url)
              .then((response) => {
                this.parameters = response.data;
              });
        }
      }
    },
    mounted() {
    },
    props: {
      roles: {
        type: Array,
        required: true
      },
      people: {
        type: Array,
        required: true
      },
      responsibles: {
        type: Array,
        required: true
      }
    }

  }
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
